import { render, staticRenderFns } from "./TeacherOrder.vue?vue&type=template&id=c0623002&"
import script from "./TeacherOrder.vue?vue&type=script&lang=js&"
export * from "./TeacherOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports